import { useSelect } from "@chakra-ui/react";
import { notify } from "common/toastUtil";
import { validateAddGateway } from "common/validation";
import React, { use, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateAppAdminOrAgent } from "services/userService";
import { updateAppAdminOrAgentThunk } from "slices/userSlice";
import { addPaymentGatewayRegisterThunk } from "slices/userSlice";
import { getGateWayListThunk } from "slices/userSlice";
import { updateGateWayThunk } from "slices/userSlice";
import { fetchAdminThunk } from "slices/userSlice";
import { resetSubmission } from "slices/userSlice";
import { addAppAdminOrAgentThunk } from "slices/userSlice";

export default function AddPaymentModal({open, setOpen,singleData,setSingleData}) {

  const [form, setForm] = React.useState({
    gateway_name: "",
    secret_key: "",
    publishing_key: "",
    mode: "",
  });
    const [errors, setErrors] = useState({
 gateway_name: "",
    secret_key: "",
    publishing_key: "",
    mode: "",
    });
const dispatch = useDispatch();
const {data,error,status}=useSelector((state) => state.users);
const isEdit = Object.keys(singleData).length > 0;
  const handleChange = (e) => {
    const { name, value } = e.target;
    const updated = { ...form, [name]: value };
    setForm(updated);
       const fieldError = validateAddGateway(updated,isEdit);
        setErrors({ ...errors, [name]: fieldError[name] ?? "" });
  };

  const handleSubmit = () => {
    const validationErrors = validateAddGateway(form,isEdit);
     setErrors(validationErrors);
    const isValid = Object.values(validationErrors).every((x) => x === "")
    if (isValid) {
      if(isEdit){
      dispatch(updateGateWayThunk({
        ...form,
        id:singleData?._id
      }))
      }else{
        dispatch(addPaymentGatewayRegisterThunk(form))
      }
     
    }
  };
const didNotify = useRef(false);

useEffect(() => {
  if (data?.status === 201 && !didNotify.current) {
    didNotify.current = true;

    setOpen(false);
    notify("success", data.message);
    setForm({ gateway_name: "", secret_key: "", publishing_key: "", mode: "" });
    setErrors({ gateway_name: "", secret_key: "", publishing_key: "", mode: "" });
    dispatch(resetSubmission());
    dispatch(getGateWayListThunk());
  }else if ((data?.status && data.status !== 200 && data.status !== 201) || error) {
      // Only trigger error notification for truly "other" statuses
      if (error) notify("error", error);
    }
}, [data?.status, dispatch]);
useEffect(()=>{
  if(singleData){
    setForm({
     gateway_name:singleData?.gateway_name || "",
    secret_key:singleData?.secret_key || "",
    publishing_key:singleData?.publishing_key || "",
    mode:singleData?.mode || "",
    });
  }
},[singleData])

  return (
    <>
  

      {open && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 bg-[#0d0d0c99] "
          aria-modal="true"
          role="dialog"
        >
          <div className="bg-white dark:bg-navy-700 rounded-xl w-full max-w-md mx-4 p-6">
            <h2 className="text-xl font-bold text-gray-800 dark:text-white mb-4">
              Create Paymnet Gateway
            </h2>
            {/* Email */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Gateway Name*
              </label>
              <input
                name="gateway_name"
                type="text"
                value={form.gateway_name}
                placeholder="Enter gateway name"
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {
                errors.gateway_name && (
                <p className="text-red-500 text-sm mt-1">{errors.gateway_name}</p>)
              }
            </div>
            {/* Password */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Secret Key*
              </label>
              <input
                name="secret_key"
                type="text"
                  placeholder="Enter secret key"
                value={form.secret_key}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {
                errors.secret_key && (
                <p className="text-red-500 text-sm mt-1">{errors.secret_key}</p>)
              }
            </div>
            {/* Name */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Publishing Key*
              </label>
              <input
                name="publishing_key"
                type="text"
                  placeholder="Enter publishing key"
                value={form.publishing_key}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {
                errors.publishing_key && (
                <p className="text-red-500 text-sm mt-1">{errors.publishing_key}</p>)
              }
            </div>
            {/* Role */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Mode*
              </label>
              <select
                name="mode"
                value={form.mode}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                 <option value="">Select Mode</option>
                <option value="Live">Live Mode</option>
                <option value="Test">Test Mode</option>
              </select>
            </div>
            {
                errors.mode && (
                <p className="text-red-500 text-sm mt-1">{errors.mode}</p>)
              }
            {/* Buttons */}
            <div className="flex justify-end space-x-3">
              <button
                onClick={() =>{
              setSingleData({})
                  setForm({
                 gateway_name: "",
    secret_key: "",
    publishing_key: "",
    mode: "",
                  });
                  setErrors({
                    gateway_name: "",
    secret_key: "",
    publishing_key: "",
    mode: "",
                  });
                      setOpen(false);
                }}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-600 rounded hover:bg-gray-300 dark:hover:bg-gray-500"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
